import React from "react"
import { Route } from "react-router-dom"
import { ApolloError } from "apollo-client"

export const ErrorGuardRoute = ({ error }: { error: ApolloError }) => (
  <Route
    render={() => {
      throw error
    }}
  />
)
